/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, NotificationEmailDeliveriesControllerEmailPreviewPathParams, NotificationEmailDeliveriesControllerEmailPreview400, NotificationEmailDeliveriesControllerEmailPreview401, NotificationEmailDeliveriesControllerEmailPreview403, NotificationEmailDeliveriesControllerEmailPreview404 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerEmailPreview";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationEmailDeliveriesControllerEmailPreview } from "../../clients/notification-email-deliveriesService/notificationEmailDeliveriesControllerEmailPreview";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationEmailDeliveriesControllerEmailPreviewQueryKey = (id: NotificationEmailDeliveriesControllerEmailPreviewPathParams["id"]) => [{
  url: '/api/v1/notification-email-deliveries/:id/email-preview',
  params: {
    id: id
  }
}] as const;
export type NotificationEmailDeliveriesControllerEmailPreviewQueryKey = ReturnType<typeof notificationEmailDeliveriesControllerEmailPreviewQueryKey>;
export function notificationEmailDeliveriesControllerEmailPreviewQueryOptions(id: NotificationEmailDeliveriesControllerEmailPreviewPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationEmailDeliveriesControllerEmailPreviewQueryKey(id);
  return queryOptions<NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerEmailPreview400 | NotificationEmailDeliveriesControllerEmailPreview401 | NotificationEmailDeliveriesControllerEmailPreview403 | NotificationEmailDeliveriesControllerEmailPreview404>, NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationEmailDeliveriesControllerEmailPreview(id, config);
    }
  });
}

/**
 * @description Renders the envelope's current members for any status. Not a replay of what was sent: send-time eligibility (read state, per-event OFF, the master switch) is deliberately not applied. Mutates nothing.
 * @summary Preview the email a delivery renders to, without sending it
 * {@link /api/v1/notification-email-deliveries/:id/email-preview}
 */
export function useNotificationEmailDeliveriesControllerEmailPreview<TData = NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, TQueryData = NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, TQueryKey extends QueryKey = NotificationEmailDeliveriesControllerEmailPreviewQueryKey>(id: NotificationEmailDeliveriesControllerEmailPreviewPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerEmailPreview400 | NotificationEmailDeliveriesControllerEmailPreview401 | NotificationEmailDeliveriesControllerEmailPreview403 | NotificationEmailDeliveriesControllerEmailPreview404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationEmailDeliveriesControllerEmailPreviewQueryKey(id);
  const query = useQuery({
    ...notificationEmailDeliveriesControllerEmailPreviewQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationEmailDeliveriesControllerEmailPreview400 | NotificationEmailDeliveriesControllerEmailPreview401 | NotificationEmailDeliveriesControllerEmailPreview403 | NotificationEmailDeliveriesControllerEmailPreview404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}